<template>
    <modal-template>
        <div slot="header">
            {{ trans('user-import.label.configuration') }}
        </div>

        <div slot="body">
            <alert class="h:margin-bottom-8" type="warning" v-if="resendCredentials">
                <div v-if="resendCredentials">
                    {{ trans('user-import.alert.resend_credentials') }}
                </div>
            </alert>

            <alert class="h:margin-bottom-8" type="warning" v-if="deleteNotImportedUsers">
                <div v-if="deleteNotImportedUsers">
                    {{ trans('user-import.alert.delete_not_imported_users') }}
                </div>
            </alert>

            <div class="form form-section">
                <div class="form-row">
                    <div class="form-row__col form-row__col--one-half">
                        <checkbox v-model="resendCredentials" name="resend_credentials">
                            {{ trans('user-import.label.resend_credentials') }}
                        </checkbox>
                    </div>

                    <div class="form-row__col form-row__col--one-half" v-if="currentUser.isAdmin()">
                        <checkbox v-model="deleteNotImportedUsers" name="delete_not_imported_users">
                            {{ trans('user-import.label.delete_not_imported_users') }}
                        </checkbox>
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer">
            <button type="button" @click="$emit('close')" class="btn btn--secondary">{{ trans('buttons.cancel') }}</button>
            <button type="button" @click="saveConfig" class="btn btn--primary">{{ trans('buttons.ok') }}</button>
        </div>
    </modal-template>
</template>

<script>
import { EventBus } from '../eventbus.js';

export default {
    props: {
        oldResendCredentials: {
            default: false,
        },
        oldDeleteNotImportedUsers: {
            default: false,
        },
    },

    data() {
        return {
            resendCredentials: this.oldResendCredentials,
            deleteNotImportedUsers: this.oldDeleteNotImportedUsers,
        }
    },

    methods: {
        saveConfig() {
            EventBus.$emit('update-config', {
                'resend_credentials': this.resendCredentials,
                'delete_not_imported_users': this.deleteNotImportedUsers,
            });

            this.$emit('close');
        }
    }
}
</script>
